<template>
  <CustomPage :noTitle="true">
    <div slot="content" class="page-content">
      <div class="discovery-create-goods-container">
        <Header ref="Header" @search="search" />
        <div class="list-wrapper">
          <VirtualList
            :list="list"
            :dataComponent="dataComponent"
            @getData="getData"
            :finished="finished"
          />
        </div>
      </div>
    </div>
  </CustomPage>
</template>

<script>
import { nanoid } from 'nanoid'
import CustomPage from '@/components/custom-page.vue'
import Header from './components/Header'
import VirtualList from '@/components/VirtualList'
import dataComponent from './components/Item'
import { getMaterialGoodsList } from '@/api/discovery'
export default {
  components: { CustomPage, Header, VirtualList },
  data() {
    return {
      dataComponent,
      list: [],
      finished: false,
    }
  },
  methods: {
    search() {
      this.list = []
      this.finished = false
      this.getData()
    },
    getData() {
      const params = {
        goodsInfoName: this.$refs.Header.value
      }
      getMaterialGoodsList(this.tools.removePropertyOfNull(params))
        .then((res) => {
          this.list = res.data.map((item) => ({ ...item, id: nanoid() }))
          this.finished = true
        })
    },
  },
}
</script>

<style lang="less" scoped>
.page-content {
  height: 100%;
}
.discovery-create-goods-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  .list-wrapper {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    .virtual-list {
      padding-top: 24px;
    }
  }
}
</style>